export default __webpack_public_path__ + "assets/images/36791107a72cf1fb4640bc626c871618.svg";